import { LngLat } from "mapbox-gl";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { usePipedriveStore } from "../..";
import useProperty from "../../hooks/useProperty";
import PropertySummary from "../property/PropertySummary";

function DealDetailsPropertyTab() {
    const { id } = useParams();
    const pipedriveStore = usePipedriveStore();
    const deal = useMemo(() => computed(() => pipedriveStore.deals.find(d => d.id.toString() === id)!), [id]).get();
    const coordinate = useMemo(() => new LngLat(deal.lon, deal.lat), [deal]);
    const { property } = useProperty(coordinate);

    if (!property)
        return null;

    return <PropertySummary property={property} />;
}

export default observer(DealDetailsPropertyTab);
